// src/components/Login.js
import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Header, HomePageContainer } from '../../styled/Homepage';
import { ErrorMessage } from '../components/Form';

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
`;

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 300px;
`;

const Input = styled.input`
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const Button = styled.button`
  background-color: #007bff;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const Loginpage = ({
  handleLoggedIn = () => console.log('after login'),
}) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const submitLogin = async () => {
    setError(null);
    let data = JSON.stringify({
      "username": username,
      "password": password
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: process.env.REACT_APP_AUTH_URL,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    await axios.request(config).then(async (response) => {
      if (response.data && response.data.token) {
        await Cookies.set('gen.ui.authentication', response.data.token, { expires: 8, sameSite: 'strict'})
        handleLoggedIn(true)
      } else {
        setError("There is an error with login, try again")
      }
      console.log(response.data);
    }).catch(() => {
      setError("Username and password doesnt match our record")
    })
  }

  const checkTokenExist = () => {
    const auth = Cookies.get('gen.ui.authentication');
  
    if (auth) {
      handleLoggedIn(true)
    }
  }

  useEffect(() => {
    checkTokenExist()
    // eslint-disable-next-line
  }, [])

  return (
    <HomePageContainer>
      <Header>
        <h1>Kata - Gen UI</h1>
        <p>For Internal purpose only.</p>
      </Header>
      <LoginContainer>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <LoginForm autoComplete="off">
          <Input 
            type="text" 
            placeholder="Username" 
            autoComplete="off" 
            required
            onChange={(e) => setUsername(e.target.value)}
          />
          <Input 
            type="password" 
            placeholder="Password" 
            autoComplete="off" 
            required
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="button" onClick={() => submitLogin()}>Login</Button>
        </LoginForm>
      </LoginContainer>
    </HomePageContainer>
  );
};

export default Loginpage;
